const topics = [
  { id: 1, name: '#某顶流塌房', hot: '983万', color: 'bg-primary-100 text-primary-700' },
  { id: 2, name: '#直播间口误', hot: '756万', color: 'bg-accent-100 text-accent-700' },
  { id: 3, name: '#选秀黑幕', hot: '689万', color: 'bg-secondary-100 text-secondary-700' },
  { id: 4, name: '#聊天记录泄露', hot: '621万', color: 'bg-primary-100 text-primary-700' },
  { id: 5, name: '#品牌解约潮', hot: '534万', color: 'bg-accent-100 text-accent-700' },
  { id: 6, name: '#综艺翻脸', hot: '487万', color: 'bg-secondary-100 text-secondary-700' },
  { id: 7, name: '#刷单造假', hot: '412万', color: 'bg-primary-100 text-primary-700' },
  { id: 8, name: '#UP主人设崩塌', hot: '378万', color: 'bg-accent-100 text-accent-700' },
  { id: 9, name: '#内部邮件泄露', hot: '345万', color: 'bg-secondary-100 text-secondary-700' },
  { id: 10, name: '#粉丝脱粉潮', hot: '298万', color: 'bg-primary-100 text-primary-700' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          热门话题<i className="ri-hashtag text-primary-500 ml-2"></i>
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">当前最火的话题都在这里</p>

        <div className="mt-8 flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium cursor-pointer transition-all hover:scale-105 ${topic.color}`}
            >
              <span>{topic.name}</span>
              <span className="text-xs opacity-70 whitespace-nowrap">{topic.hot}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}